
export default [
    {
      path: '/interactiveLive/InteractiveLiveList',
      name: 'interactiveLiveList',
      hidden: true,
      component: () => import('@/views/interactiveLive/InteractiveLiveList'),
      meta: { title: 'menu.interactiveLiveList', keepAlive: true, permission: ['table'] },
    },
    {
      path: '/interactiveLive/CreateInteractiveLive',
      name: 'createInteractiveLive',
      hideChildrenInMenu: true,
      hidden: true,
      component: () => import('@/views/interactiveLive/CreateInteractiveLive'),
      meta: { title: 'menu.createInteractiveLive', permission: ['form'] },
    },
    // 直播详情
    {
      path: '/interactiveLive/InteractiveLiveDetail',
      name: 'interactiveLiveDetail',
      hidden: true,
      component: () => import('@/views/interactiveLive/InteractiveLiveDetail'),
      meta: { title: 'menu.InteractiveLiveDetail', permission: ['form'] },
    },
    // 弹幕详情
    {
      path: '/interactiveLive/BarrageDetails',
      name: 'BarrageDetails',
      hidden: true,
      component: () => import('@/views/interactiveLive/BarrageDetails'),
      meta: { title: 'menu.BarrageDetails', permission: ['form'] },
    },
  ]